/* F24 — Landing Proveedor de Maquinaria (ICP1)
   - reveal-on-scroll  - clic-a-WhatsApp event (defensive)
   - product carousel (arrows + progress)  - KPI count-up  - hero parallax
   Idempotent; if this script fails to load, content stays visible (CSS gate). */
(function () {
  'use strict';
  if (window.__f24mInit) return;
  window.__f24mInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // JS present -> allow CSS hidden/reveal states (no blank page if JS ever fails)
  document.documentElement.classList.add('f24m-js');

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var nodes = document.querySelectorAll('.f24m-anim');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
    setTimeout(function () { // failsafe: never leave on-screen content invisible
      document.querySelectorAll('.f24m-anim:not(.is-in)').forEach(function (n) {
        if (n.getBoundingClientRect().top < (window.innerHeight || 0)) n.classList.add('is-in');
      });
    }, 1500);
  }

  /* ---------- clic-a-WhatsApp conversion event (defensive) ---------- */
  function fireWA(group, ctaText) {
    var p = { source: 'landing-maquinaria', icp: 'icp1-b2b', group: group || 'general', cta: ctaText || '' };
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'ClicWhatsApp', p); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'clic_whatsapp', p); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'clic_whatsapp' }, p)); } catch (e) {}
    try { if (window.console && console.debug) console.debug('[F24] clic_whatsapp', p); } catch (e) {}
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-wa]');
    if (!a) return;
    fireWA(a.getAttribute('data-wa-group'), (a.textContent || '').trim().slice(0, 60));
  }, true);

  /* ---------- product carousel ---------- */
  function initCarousels() {
    document.querySelectorAll('.f24m-railwrap').forEach(function (wrap) {
      var rail = wrap.querySelector('.f24m-rail');
      // nav buttons live in the group's action row (sibling of the rail wrap)
      var scope = wrap.closest('.f24m-group') || wrap;
      var prev = scope.querySelector('[data-rail="prev"]');
      var next = scope.querySelector('[data-rail="next"]');
      var bar = wrap.querySelector('.f24m-progress__bar');
      if (!rail) return;

      function step() {
        var card = rail.querySelector('.f24m-card');
        var gap = parseInt(getComputedStyle(rail).columnGap || '14', 10) || 14;
        return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      }
      function maxScroll() { return rail.scrollWidth - rail.clientWidth; }
      function sync() {
        var hasOverflow = maxScroll() > 4;
        scope.classList.toggle('has-overflow', hasOverflow);
        wrap.classList.toggle('has-overflow', hasOverflow);
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= maxScroll() - 2;
        if (bar) {
          var ratio = rail.clientWidth / rail.scrollWidth;
          var pos = maxScroll() > 0 ? rail.scrollLeft / maxScroll() : 0;
          bar.style.width = Math.max(12, Math.min(100, ratio * 100)) + '%';
          bar.style.transform = 'translateX(' + (pos * (100 / Math.max(ratio, 0.0001) - 100)) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- KPI count-up ---------- */
  function initCountUp() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    function run(el) {
      var raw = el.getAttribute('data-countup');
      var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (isNaN(target)) { return; }
      if (reduce) { el.textContent = raw; return; }
      var dur = 1100, t0 = null;
      function frame(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        var val = Math.round(target * (1 - Math.pow(1 - k, 3)));
        el.textContent = raw.replace(/[0-9][0-9.,\s]*[0-9]|[0-9]/, val.toLocaleString('es-MX'));
        if (k < 1) window.requestAnimationFrame(frame);
        else el.textContent = raw;
      }
      window.requestAnimationFrame(frame);
      // guarantee the final value lands even if rAF is throttled (e.g. background tab)
      setTimeout(function () { el.textContent = raw; }, dur + 350);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- hero glow parallax ---------- */
  function initParallax() {
    if (reduce) return;
    var glow = document.querySelector('.f24m-hero__glow');
    if (!glow) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY || 0;
        glow.style.transform = 'translateY(' + (y * 0.18) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- exit-intent / time pop-up ---------- */
  function initPopup() {
    var pop = document.querySelector('.f24m-pop');
    if (!pop) return;
    var KEY = 'f24m_pop_seen';
    var seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    var delay = parseInt(pop.getAttribute('data-delay') || '18', 10) * 1000;

    function open() {
      if (seen || pop.classList.contains('is-open')) return;
      seen = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      pop.classList.add('is-open');
      try { if (typeof window.gtag === 'function') window.gtag('event', 'popup_view', { source: 'landing-maquinaria' }); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'popup_view', source: 'landing-maquinaria' }); } catch (e) {}
    }
    function close() { pop.classList.remove('is-open'); }

    pop.querySelectorAll('[data-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.classList.contains('f24m-pop__veil')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // time fallback (all devices)
    var timer = setTimeout(open, delay);
    // exit-intent (desktop): cursor leaves toward the top
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 4) { clearTimeout(timer); open(); }
    });
  }

  /* ---------- cotizador rápido -> WhatsApp ---------- */
  function initCotizador() {
    document.querySelectorAll('.f24m-quote__form').forEach(function (form) {
      var base = form.getAttribute('data-wa-base') || 'https://wa.me/5213317903630';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var get = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? (el.value || '').trim() : ''; };
        var equipo = get('equipo'), uso = get('uso'), cant = get('cantidad');
        var msg = 'Hola Ferre24, quiero cotizar.'
          + (equipo ? ' Equipo: ' + equipo + '.' : '')
          + (uso ? ' Para: ' + uso + '.' : '')
          + (cant ? ' Cantidad: ' + cant + '.' : '')
          + ' ¿Me asesoran?';
        fireWA('cotizador', equipo || 'cotizador');
        var waUrl = base + '?text=' + encodeURIComponent(msg); if (window.F24_STAMP) { try { waUrl = window.F24_STAMP(waUrl); } catch (e) {} } window.open(waUrl, '_blank', 'noopener');
      });
    });
  }

  function boot() { initReveal(); initCarousels(); initCountUp(); initParallax(); initPopup(); initCotizador(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
